exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-keywords-cell{color:white}.admin-keywords-actions{display:flex;justify-content:flex-end}.admin-keywords-settings-footer{display:flex;width:100%;justify-content:flex-end;align-items:center}.admin-keywords-tracking-active{background-color:#3c763d}.admin-keywords-tracking-inactive{background-color:#dc3545}\n", ""]);

// exports
